import { useEffect } from "react";

/**
 * Lightweight per-page meta setter — no new dependency.
 * Sets document.title and the <meta name="description"> + og:title/description on mount.
 */
export default function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const upsert = (selector, attr, value) => {
        let el = document.head.querySelector(selector);
        if (!el) {
          el = document.createElement("meta");
          const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
          el.setAttribute(k, (v || "").replace(/"/g, ""));
          document.head.appendChild(el);
        }
        el.setAttribute(attr, value);
      };
      upsert('meta[name="description"]', "content", description);
      upsert('meta[property="og:title"]', "content", title || "");
      upsert('meta[property="og:description"]', "content", description);
    }
  }, [title, description]);
  return null;
}
